import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { BuyProps } from "../../../interfaces/containers";
import PickUpPoint from "../../../pages/Buy/PickUpPoint";
import { setStep, postTransaction, cleanPostTransaction, setCleanAll, setValidation as setValidationReducer, getPickUpPoints, setInspectionPoint } from "../../../actions/buy";
import { getIsValidDocuments, cleanIsValidDocuments } from "../../../actions/documents";

function mapStateToProps(state: BuyProps) {
    return{
        user: state.auth.user,
        publication: state.buy.publication,
        step: state.buy.step,
        method: state.buy.method,
        transactionFetching: state.buy.transactionFetching,
        creditSimulation: state.buy.creditSimulation,
        inspectionPoints: state.buy.inspectionPoints,
        financing: state.buy.financing,
        valid: state.documents.valid
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        setStep,
        setInspectionPoint,
        postTransaction,
        cleanPostTransaction,
        setCleanAll,
        getIsValidDocuments, 
        cleanIsValidDocuments,
        setValidationReducer,
        getPickUpPoints
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(PickUpPoint);